import { defaultCommitmentValue } from "./portfolio-creation-edit-manual-composition/insPortfolioCreationManualCompositionGrid";
import { moveElementsToBeginning } from "common/array-helper";
import { formatToColumnTypes } from "components/widgets/grid/grid-column-types";
// Helper function to format camelCase to readable text
const formatHeaderName = (label) => label
    .replace(/(?<upper>[A-Z])/gu, (match) => ` ${match}`)
    .replace(/^./u, (str) => str.toUpperCase())
    .trim();
export const addCustomFieldsAsDatapoints = (customFields, datapoints) => {
    customFields.forEach((customField) => {
        if (customField.metadata) {
            const customDatapointId = customField.id;
            const isCustomDatapointExist = datapoints.some((datapoint) => datapoint.datapoint.custom === customDatapointId);
            if (!isCustomDatapointExist) {
                const customDatapoint = {
                    datapoint: { custom: customDatapointId },
                    name: customDatapointId?.replace(/\./gu, "")
                };
                datapoints.push(customDatapoint);
            }
        }
    });
};
export const addCustomFieldsAsCols = (customFields, cols) => {
    customFields.forEach((customField) => {
        if (customField.metadata) {
            const fieldId = customField.id?.replace(/\./gu, "");
            const isCustomColExist = cols.some((col) => col.field === fieldId);
            if (!isCustomColExist) {
                const label = customField.metadata.label.toString();
                const formattedLabel = formatHeaderName(label);
                const customCol = {
                    field: fieldId,
                    headerName: formattedLabel,
                    headerTooltip: formattedLabel,
                    type: formatToColumnTypes[customField.metadata.format],
                    width: 200
                };
                cols.push(customCol);
            }
        }
    });
};
export const getSupportedCurrencies = () => Intl.supportedValuesOf("currency");
export const getPortfolioCurrencies = () => moveElementsToBeginning(getSupportedCurrencies(), ["CNY", "JPY", "GBP", "EUR", "USD"]);
export const getPortfolioCurrencyOptions = () => {
    const currencies = getPortfolioCurrencies();
    const currencyOptionsList = [
        {
            values: currencies
                .map((curr) => ({
                displayValue: curr,
                value: curr
            }))
        }
    ];
    return currencyOptionsList;
};
export const getUserGroupsOptions = (userGroups, info, isEdit) => {
    const userGroupOptionsList = [
        {
            values: userGroups
                .map((userGroup) => ({
                displayValue: String(userGroup.name),
                value: userGroup.id
            }))
        }
    ];
    if (isEdit && !userGroupOptionsList[0].values.some((x) => x.value === info.userGroupId)) {
        userGroupOptionsList[0].values.push({ displayValue: info.userGroupName ?? "", value: info.userGroupId });
    }
    return userGroupOptionsList;
};
export const parseRowsToPortfolioAssets = (selectedRowIds, editedRows, originalRows) => selectedRowIds?.map((id) => {
    const [fundId, investorId] = id.split("-");
    if (investorId) {
        return {
            commitment: editedRows[fundId + investorId]?.Commitment?.amount,
            fundId,
            investorId
        };
    }
    if (editedRows[fundId]) {
        return { commitment: editedRows[fundId].Commitment.amount, fundId };
    }
    return {
        commitment: originalRows
            .find((r) => r.Id === fundId && (investorId ? r.InvestorId === investorId : !r.InvestorId))?.Commitment?.amount ?? defaultCommitmentValue.amount,
        fundId
    };
});
